var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19961 6C4.04048 6 3.88787 6.06321 3.77535 6.17574C3.66282 6.28826 3.59961 6.44087 3.59961 6.6C3.59961 6.75913 3.66282 6.91174 3.77535 7.02426C3.88787 7.13679 4.04048 7.2 4.19961 7.2H10.1996C10.3587 7.2 10.5114 7.13679 10.6239 7.02426C10.7364 6.91174 10.7996 6.75913 10.7996 6.6C10.7996 6.44087 10.7364 6.28826 10.6239 6.17574C10.5114 6.06321 10.3587 6 10.1996 6H4.19961Z",
    fill: "url(#paint0_linear_937_7535)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 10.2016C3.59961 10.0424 3.66282 9.88982 3.77535 9.7773C3.88787 9.66478 4.04048 9.60156 4.19961 9.60156H10.1996C10.3587 9.60156 10.5114 9.66478 10.6239 9.7773C10.7364 9.88982 10.7996 10.0424 10.7996 10.2016C10.7996 10.3607 10.7364 10.5133 10.6239 10.6258C10.5114 10.7383 10.3587 10.8016 10.1996 10.8016H4.19961C4.04048 10.8016 3.88787 10.7383 3.77535 10.6258C3.66282 10.5133 3.59961 10.3607 3.59961 10.2016Z",
    fill: "url(#paint1_linear_937_7535)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19961 13.1992C4.04048 13.1992 3.88787 13.2624 3.77535 13.375C3.66282 13.4875 3.59961 13.6401 3.59961 13.7992C3.59961 13.9583 3.66282 14.111 3.77535 14.2235C3.88787 14.336 4.04048 14.3992 4.19961 14.3992H6.59961C6.75874 14.3992 6.91135 14.336 7.02387 14.2235C7.1364 14.111 7.19961 13.9583 7.19961 13.7992C7.19961 13.6401 7.1364 13.4875 7.02387 13.375C6.91135 13.2624 6.75874 13.1992 6.59961 13.1992H4.19961Z",
    fill: "url(#paint2_linear_937_7535)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 0C2.84087 0 2.68826 0.0632142 2.57574 0.175736C2.46321 0.288258 2.4 0.44087 2.4 0.6V1.2H1.8C1.32261 1.2 0.864773 1.38964 0.527208 1.72721C0.189642 2.06477 0 2.52261 0 3V17.4C0 17.8774 0.189642 18.3352 0.527208 18.6728C0.864773 19.0104 1.32261 19.2 1.8 19.2H9C9.07885 19.2001 9.15695 19.1847 9.22984 19.1547C9.30273 19.1246 9.36898 19.0805 9.4248 19.0248L14.2248 14.2248C14.2805 14.169 14.3246 14.1027 14.3547 14.0298C14.3847 13.9569 14.4001 13.8788 14.4 13.8V3C14.4 2.52261 14.2104 2.06477 13.8728 1.72721C13.5352 1.38964 13.0774 1.2 12.6 1.2H12V0.6C12 0.44087 11.9368 0.288258 11.8243 0.175736C11.7117 0.0632142 11.5591 0 11.4 0C11.2409 0 11.0883 0.0632142 10.9757 0.175736C10.8632 0.288258 10.8 0.44087 10.8 0.6V1.2H7.8V0.6C7.8 0.44087 7.73679 0.288258 7.62426 0.175736C7.51174 0.0632142 7.35913 0 7.2 0C7.04087 0 6.88826 0.0632142 6.77573 0.175736C6.66321 0.288258 6.6 0.44087 6.6 0.6V1.2H3.6V0.6C3.6 0.44087 3.53679 0.288258 3.42426 0.175736C3.31174 0.0632142 3.15913 0 3 0ZM12.6 2.4C12.7591 2.4 12.9117 2.46321 13.0243 2.57574C13.1368 2.68826 13.2 2.84087 13.2 3V13.2H10.2C9.72261 13.2 9.26477 13.3896 8.92721 13.7272C8.58964 14.0648 8.4 14.5226 8.4 15V18H1.8C1.64087 18 1.48826 17.9368 1.37574 17.8243C1.26321 17.7117 1.2 17.5591 1.2 17.4V3C1.2 2.84087 1.26321 2.68826 1.37574 2.57574C1.48826 2.46321 1.64087 2.4 1.8 2.4H12.6ZM12.3516 14.4L9.6 17.1516V15C9.6 14.8409 9.66321 14.6883 9.77573 14.5757C9.88826 14.4632 10.0409 14.4 10.2 14.4H12.3516Z",
    fill: "url(#paint3_linear_937_7535)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_937_7535",
    x1: 10.7996,
    y1: 7.2,
    x2: 9.37945,
    y2: 4.07418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_937_7535",
    x1: 10.7996,
    y1: 10.8016,
    x2: 9.37945,
    y2: 7.67574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_937_7535",
    x1: 7.19961,
    y1: 14.3992,
    x2: 5.32271,
    y2: 12.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_937_7535",
    x1: 14.4,
    y1: 19.2,
    x2: -1.03223,
    y2: 14.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9E38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.d829c8c73a78beeab7edbc68f3d0beb9.svg";
export { ForwardRef as ReactComponent };